module.exports = __webpack_public_path__ + "static/media/firewall.6efb9f12.svg";